export enum AnnualReportBusinessModel {
    OR = 'OR',
    HGB = 'HGB',
}
